// Central frontend config. Category meta, answer options, storage keys.
// Pseudonyms come from the backend (edit them in /app/backend/config.py).

export const CATEGORIES = {
  FUN: { label: "Fun", color: "#F2C66D", intensity: 1 },
  DISCOVERY: { label: "Découverte", color: "#74A7FF", intensity: 1 },
  PERSONAL: { label: "Personnel", color: "#B69CFF", intensity: 2 },
  INTIMATE: { label: "Intime", color: "#E28AA8", intensity: 3 },
  SPICY: { label: "Épicé", color: "#FF6B72", intensity: 4 },
};

export const ANSWERS = [
  { value: "yes", label: "Oui", emoji: "❤️" },
  { value: "maybe", label: "Peut-être", emoji: "🤔" },
  { value: "no", label: "Non", emoji: "✕" },
];

export const ANSWER_META = {
  yes: { label: "Oui", emoji: "❤️" },
  maybe: { label: "Peut-être", emoji: "🤔" },
  no: { label: "Non", emoji: "✕" },
};

export const SOUND_SRC = "/sounds/match.mp3";

export const STORAGE_USER = "discovery_user_id";
export const STORAGE_TOKEN = "discovery_session_token";
export const STORAGE_SOUND = "discovery_sound_on";
